Vue.component('surveys-home', {
  mounted() {
    let instance = this

    // @TODO: Export common functions with home.js to mixin or smth

    // Process url parameters
    var url = document.location.toString();

    if (url.match('#')) {
        $('.spark-settings-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
    } else {
        $('.spark-settings-tabs a[href="#home"]').tab('show');
    }

    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      let id = e.target.getAttribute('aria-controls')
      instance.updatePageViewTrackers(e.target)
      instance.$eventHub.$emit('activateTab', id)
    })
  }
})
